import deps from "../depsloader";

export default () => {
  document.addEventListener("DOMContentLoaded", () => {
  deps.load("shufflejs").then((ShuffleJS) => {
      const elms = document.querySelectorAll(".filter-container");
      elms.forEach((elm) => {
        const elmItems = elm.querySelectorAll(".filtr-item");
        let heighestItem = 0;
        for (const eitem of elmItems) {
          if (eitem.offsetHeight > heighestItem) {
            heighestItem = eitem.offsetHeight;
          }
        }

        for (const eitem of elmItems) {
          eitem.style.height = heighestItem + "px";
        }

        const shuffleInstance = new ShuffleJS(elm, {
          itemSelector: ".filtr-item",
          isCentered: true
        });

        const sortControls = document.querySelectorAll('.filter-sort-btn');
        sortControls.forEach((node) =>
          node.addEventListener('click', function() {
            sortControls.forEach((control) => control.classList.remove('active'));
            node.classList.add('active');

            shuffleInstance.filter(node.dataset.filter);
          })
        );
      });
    })
  });
}
